import { Tracker } from '../trackers';

export interface LineItem {
  ProductID: string;
  Quantity?: number;
  Price?: number;
}

export interface Cart {
  LineItems: LineItem[];
  TotalAmount: string;
}

export interface RawEvent {
  eventName: string;
  eventId?: string;
  shopId?: string;
  cart?: Cart;
  orderId?: string;
  externalId?: string;
}

declare global {
  interface Window {
    _conv_q: (string | number)[][];
  }
}

export class ConvertTracker implements Tracker {
  private projectId: string;
  private targetProductIds?: string[];
  private goalId: string;

  constructor(projectId: string, goalId: string, targetProductIds?: string[]) {
    if (!projectId) {
      throw new Error('ConvertTracker requires a project ID.');
    }
    this.projectId = projectId;
    this.targetProductIds = targetProductIds;
    this.goalId = goalId;
  }

  Init(): void {
    this.injectScript();
  }

  private injectScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `//cdn-4.convertexperiments.com/v1/js/${this.projectId}.js?environment=production`;
    document.head.appendChild(script);

    console.log(`Convert project script loaded: ${this.projectId}`);
  }

  private getCookie(name: string): string | undefined {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts?.pop()?.split(';').shift();
  }

  private getVariantId(str: string) {
    const decoded = decodeURIComponent(str);
    const m = decoded.match(/(?:^|\*)exp:\{[^]*?v\.(\d+)-g\./);
    return m ? Number(m[1]) : null;
  }

  async TrackEvent(_event: RawEvent): Promise<void> {
    if (_event.eventName === 'Purchase') {
      const lineItems = _event.cart?.LineItems ?? [];
      const productIdsInCart = lineItems.map(item =>
        item.ProductID?.split('/').pop(),
      );

      console.log('[Convert] Product IDs in cart:', productIdsInCart);

      const shouldFilterByProduct =
        Array.isArray(this.targetProductIds) &&
        this.targetProductIds.length > 0;

      if (
        shouldFilterByProduct &&
        !productIdsInCart.some(pid =>
          this.targetProductIds!.includes(pid || ''),
        )
      ) {
        console.log('[Convert] Skipped: No matching product ID in cart.');
        return;
      }

      const revenue = Number(_event.cart?.TotalAmount ?? 0);
      const productsCnt = lineItems.length;
      const orderId = _event.orderId ?? '';

      const conv_v = this.getCookie('_conv_v') || '';
      const variant = this.getVariantId(conv_v) || '1001193756';
      try {
        const response = await fetch(
          'https://10017720.metrics.convertexperiments.com/track',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              cid: '10017401',
              pid: '10017720',
              vid: `${Date.now()}-${Math.floor(Date.now() / 1000)}`,
              tid: orderId,
              ev: [
                {
                  evt: 'viewExp',
                  vars: [variant],
                  exps: ['100130489'],
                },
                {
                  evt: 'hitGoal',
                  goals: [100141660],
                  vars: [variant],
                  exps: ['100130489'],
                },
                {
                  evt: 'tr',
                  goals: [100141660],
                  vars: [variant],
                  exps: ['100130489'],
                  r: revenue,
                  prc: productsCnt,
                  dup: true,
                },
              ],
            }),
          },
        );
        const data = await response.json();
        console.log('[Convert] Metrics API response:', data);
      } catch (error) {
        console.error('[Convert] Metrics API error:', error);
      }
    }
  }
}
